(function () {
	'use strict';
	/*
	 * 	usage
	 * 	minDate:maxDate in jQuery datepicker format
	 *	0d:30d - shows from today to next 30 days
	 *	-1y:1y - shows from last yesr to next year
	 */
	//TODO: Add year range to display all the possible years
	angular.module('qbePortal').directive('qbDatePicker', ['$timeout', '$filter', function ($timeout, $filter) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModelCtrl) {
				var dateRange = attrs.qbDatePicker;

				//set start date and end date
				var startDate = (dateRange.split(':')[0]) ? dateRange.split(':')[0] : '';
				var endDate = (dateRange.split(':')[1]) ? dateRange.split(':')[1] : '';

				var datePickerOptions = {
					changeYear: true,
					changeMonth: true,
					minDate: startDate,
					maxDate: endDate,
					dateFormat: 'dd/mm/yy',
					yearRange: "-100:+0",
					defaultDate: '+0'
				};
				//timeout is added to add datepicker in next digest cycle
				$timeout(function () {
					element.datepicker(datePickerOptions).change(
						function (e) {
							//if user inputs an oout of range date then datepicker changes it to within range
							element.datepicker('setDate', element.datepicker('getDate'));
							//setting the ngModel explicity after the value on the textbox is modified in the previous step
							ngModelCtrl.$setViewValue($filter('date')(element.datepicker('getDate'), 'dd/MM/yyyy'));
						});

				}, 0, ngModelCtrl, element);
			}
		}
	}]);
})();
